import { useTranslation } from 'react-i18next'
import { Tabs } from 'antd'
import { PageWrapper } from './styles'
import Template from 'pages/components/Template'
import Header from 'components/Header'
import ForwardingMails from './ForwardingMails'
import ProvisioningMails from './ProvisioningMails'
import DestroyingMails from './DestroyingMails'
import moment from 'moment'


const Mails = () => {
  const { t } = useTranslation()

  return (
    <Template
      activeMenu="/mails"
      noScroll
    >
      {(currentUser, currentCenters) =>
        <PageWrapper>
          <Header
            title={t('mails.forwardings.title') + ` ${moment().format('DD/MM/yyyy')}`}
            currentUser={currentUser}
            currentCenters={currentCenters}
          />

          <Tabs defaultActiveKey="forwarding-mails">
            <Tabs.TabPane
              key="forwarding-mails"
              tab={t('mails.forwardings.mails-title')}
              className='menu'
            >
              <ForwardingMails mailType="letters" />
            </Tabs.TabPane>

            <Tabs.TabPane
              key="forwarding-parcels"
              tab={t('mails.forwardings.parcels-title')}
            >
              <ForwardingMails mailType="parcels" />
            </Tabs.TabPane>

            <Tabs.TabPane
              key="provisioning-mails"
              tab={t('mails.provisionings.title')}
            >
              <ProvisioningMails />
            </Tabs.TabPane>

            <Tabs.TabPane
              key="destroying"
              tab={t('mails.destroyings.title')}
            >
              <DestroyingMails />
            </Tabs.TabPane>
          </Tabs>
        </PageWrapper>
      }
    </Template>
  )
}

export default Mails
